import { ConsultantComponent } from './consultant/consultant.component';
import { UnderConstructionComponent } from './permits/permit-application/shared/under-construction/under-construction.component';
import { InvoiceComponent } from './carrier-account/statement/invoice/invoice.component';
import { ModuleWithProviders, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';

import { AuthGuard } from './auth.guard';
import { VehicleTypeComponent } from './maintain/vehicle-type/vehicle-type.component';
import { ListVehicleTypeComponent } from './maintain/list-vehicle-type/list-vehicle-type.component';
import { VehicleMakeComponent } from './maintain/vehicle-make/vehicle-make.component';
import { ListVehicleMakeComponent } from './maintain/list-vehicle-make/list-vehicle-make.component';
import { ListPermitTypeComponent } from './maintain/list-permit-type/list-permit-type.component';
import { PermitTypeComponent } from './maintain/permit-type/permit-type.component';
import { StatusComponent } from './maintain/status/status.component';
import { ListStatusComponent } from './maintain/list-status/list-status.component';
import { CarrierTypeComponent } from './maintain/carrier-type/carrier-type.component';
import { ListCarrierTypeComponent } from './maintain/list-carrier-type/list-carrier-type.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { AmmenduserComponent } from './ammenduser/ammenduser.component';
import { CaLandingPageComponent } from './ca-landing-page/ca-landing-page.component';
import { UsernameComponent } from './forgot/username/username.component';
import { ForgotComponent } from './forgot/forgot.component';
import { ResetComponent } from './reset/reset.component';
import { CompanydetailsComponent } from './companydetails/companydetails.component';
import { ManagementComponent } from './carrier-account/management/management.component';
import { UploaddocumentComponent } from './uploaddocument/uploaddocument.component';
import { ConfirmpasswordchangeComponent } from './reset/confirmpasswordchange/confirmpasswordchange.component';
import { CaContactPageComponent } from '../app/ca-contact-page/ca-contact-page.component';
import { ListDocumentTypeComponent } from './maintain/list-document-type/list-document-type.component';
import { DocumentTypeComponent } from './maintain/document-type/document-type.component';
import { PermitApplicationComponent } from './permits/permit-application/permit-application.component';
import { NewPermitApplicationComponent } from './permits/permit-application/new-permit-application/new-permit-application.component';
import { ViewPermitApplicationComponent } from './permits/permit-application/view-permit-application/view-permit-application.component';
import { ListCarrierTypeDocumentComponent } from './maintain/list-carrier-type-document/list-carrier-type-document.component';
import { CarrierTypeDocumentComponent } from './maintain/carrier-type-document/carrier-type-document.component';
import { TransportAssociationComponent } from './maintain/transport-association/transport-association.component';
import { TransportAssociationListComponent } from './maintain/list-transport-association/transport-association-list.component';
import { WorkflowdashboardComponent } from './workflow/workflowdashboard/workflowdashboard.component';
import { ListPermitTypeDocumentComponent } from './maintain/list-permit-type-document/list-permit-type-document.component';
import { PermitTypeDocumentComponent } from './maintain/permit-type-document/permit-type-document.component';
import { ErrorsComponent } from './shared/errors/errors.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { ApprovalManagerComponent } from './approval-manager/approval-manager.component';
import { PermitApprovalListComponent } from './approval-manager/permit-approval-list/permit-approval-list.component';

import { PermitCorrespondenceComponent } from './approval-manager/permit-correspondence/permit-correspondence.component';
import { PermitViewerComponent } from './application-approval/permit-viewer/permit-viewer.component';
import { CarriercorrespondenceComponent } from './carrier-account/approve/carriercorrespondence/carriercorrespondence.component';

import { ManagerComponent } from './carrier-account/approve/manager/manager.component';

import { AddRouteComponent } from './maintain/route-management/add-route/add-route.component';
import { ListRouteComponent } from './maintain/route-management/list-route/list-route/list-route.component';

import { ListSessionComponent } from './maintain/list-session/list-session.component';

import { ManageCountriesComponent } from './maintain/manage-countries/manage-countries.component';
import { ManageCountryPlacesComponent } from './maintain/manage-country-places/manage-country-places.component';
import { AddNewPlaceComponent } from './maintain/add-new-place/add-new-place.component';
import { ListPermitTypeVehicleComponent } from './maintain/list-permit-type-vehicle/list-permit-type-vehicle.component';
import { CorspdcComponent } from './corspdc/corspdc.component';
import { PermitListApplicationComponent } from './permit-list-application/permit-list-application.component';
import { PermitCertificateReturnComponent } from './maintain/permit-certificate-return/permit-certificate-return.component';
import { RunMaintenanceTasksComponent } from './maintain/run-maintenance-tasks/run-maintenance-tasks.component';
import { RunCorrespondenceTasksComponent } from './maintain/run-correspondence-tasks/run-correspondence-tasks.component';
import { BatchComponent } from './corspdc/batch/batch.component';
import { StatementComponent } from './carrier-account/statement/statement.component';
import { LinkCarrierAccountComponent } from './carrier-account/link-carrier-account/link-carrier-account.component';
import { DeLinkCarrierAccountComponent } from './carrier-account/delink-carrier-account/delink-carrier-account.component';
import { ManageComponent } from './permits/permit-application/timetable/manage/manage.component';
import { TimetableComponent } from './permits/permit-application/timetable/timetable.component';
import { ExtractViewsComponent } from './extract-views/extract-views/extract-views.component';
import { RunExtractsComponent } from './extract-views/extract-views/run-extracts/run-extracts.component';
import { AddDataExtractComponent } from './extract-views/extract-views/add-data-extract/add-data-extract.component';
import { ViewPermitComponent } from './maintain/view-permit/view-permit.component';
import { RenewPermitComponent } from './permits/permit-application/renew-permit/renew-permit.component';
import { ManageVehiclesComponent } from './maintain/manage-vehicles/manage-vehicles.component';
import { ExternalVehiclesComponent } from './maintain/external-vehicles/external-vehicles.component';
import { CarrierDetailsComponent } from './permits/permit-application/shared/carrier-details/carrier-details.component';
import { CalendarViewerComponent } from './shared/calendar-viewer/calendar-viewer.component';
import { ListFreightTypeComponent } from './maintain/list-freight-type/list-freight-type.component';
import { EditFreightTypeComponent } from './maintain/edit-freight-type/edit-freight-type.component';

import { CarrierComplianceListComponent } from './compliance/carrier-compliance-list/carrier-compliance-list.component';
import { ComplianceReturnListComponent } from './compliance/compliance-return-list/compliance-return-list.component';

import {SupportComponent} from './support/support.component';
import { ComplianceApplicationComponent } from './compliance/compliance-application/compliance-application.component';
import { PrintingComponent } from './approval-manager/printing/printing.component';
import {AccountDepositComponent} from './PayGate/accountDeposit.component';
import {PaymentCompleteComponent} from './PayGate/PaymentComplete/paymentComplete.component'
import { FacebookpolicyComponent } from './facebookpolicy/facebookpolicy.component';

import { ListScannerComponent } from './maintain/list-scanner/list-scanner.component';
import { AddScannerComponent } from './maintain//add-scanner/add-scanner.component';




const appRoutes: Routes = [
  //Public routes

  // { path: '', redirectTo: 'home', pathMatch: 'full' },



  { path: 'home', component: HomeComponent },
  { path: '', component: LoginComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'activate/:id', component: ActivateAccountComponent },
  { path: 'facebook-privacy', component: FacebookpolicyComponent },
//AccountDeposit
{ path: 'carrier/fundaccount/:id', component: AccountDepositComponent },
{ path: 'carrier/paymentcomplete/:id/:status/:refNum', component: PaymentCompleteComponent},

  //Admin routes

  //{ path: 'statuses/edit/:id', component: StatusmanageComponent, canActivate: [AuthGuard], data: { Roles: ['SUPERUSER', 'ADMIN'] } },
  //VehicleTypeComponent
  { path: 'vehicle/type/add', component: VehicleTypeComponent },
  { path: 'vehicle/type/edit/:id', component: VehicleTypeComponent },
  { path: 'vehicle/type/list', component: ListVehicleTypeComponent },
  { path: 'freight/type/list', component: ListFreightTypeComponent },
  { path: 'freight/type/add', component:EditFreightTypeComponent},
  { path: 'freight/type/edit/:id', component:EditFreightTypeComponent},

  //VehicleMakeCompofnent
  { path: 'vehicle/make/add', component: VehicleMakeComponent },
  { path: 'vehicle/make/edit/:id', component: VehicleMakeComponent },
  { path: 'vehicle/make/list', component: ListVehicleMakeComponent },
  //PermitTypeComponent
  { path: 'permit/type/add', component: PermitTypeComponent },
  { path: 'permit/type/edit/:id', component: PermitTypeComponent },
  { path: 'permit/type/list', component: ListPermitTypeComponent },

  //StatusComponent
  { path: 'status/add', component: StatusComponent },
  { path: 'status/edit/:id', component: StatusComponent },
  { path: 'status/list', component: ListStatusComponent },

  //CarrierTypeComponent
  { path: 'carrier/type/add', component: CarrierTypeComponent },
  { path: 'carrier/type/edit/:id', component: CarrierTypeComponent },
  { path: 'carrier/type/list', component: ListCarrierTypeComponent },

  //CompanyDetails
  { path: 'carrier/companydetails/add', component: CompanydetailsComponent },
  { path: 'carrier/companydetails/edit/id', component: CompanydetailsComponent },
  { path: 'carrier/companydetails/list', component: CompanydetailsComponent },

  //TransportAssociation
  { path: 'transport/association/add', component: TransportAssociationComponent },
  { path: 'transport/association/edit/:id', component: TransportAssociationComponent },
  { path: 'transport/association/list', component: TransportAssociationListComponent },

  //CarrieAcoount
  { path: 'carrier/create/contact', component: CaContactPageComponent },

  //LoginComponent

  //RegisterComponent
  { path: 'register', component: RegisterComponent },
  { path: 'ammenduser', component: AmmenduserComponent },
  { path: 'forgot/username', component: UsernameComponent },
  { path: 'forgot', component: ForgotComponent },
  { path: 'reset', component: ResetComponent },
  //Carrier Account Management
  { path: 'carrier/accounts', component: CaLandingPageComponent },
  { path: 'carrier/accounts/:id', component: CaLandingPageComponent },
  { path: 'carrier/account/add', component: ManagementComponent },
  { path: 'carrier/account/edit/:id', component: ManagementComponent },
  { path: 'carrier/account/edit/:id/:status', component: ManagementComponent },
  { path: 'reset/confirm', component: ConfirmpasswordchangeComponent },

  //Carrier Transcations
  { path: 'carrier/statement/:id/:carrierid', component: StatementComponent },
  { path: 'carrier/invoice/:id/:referencenumber/:carrierid', component: InvoiceComponent },

  //Session Management
  { path: 'session/list', component: ListSessionComponent },
  //Scanner
  { path: 'scanner/list', component: ListScannerComponent },
  { path: 'scanner/add', component: AddScannerComponent },
  { path: 'scanner/edit/:id', component: AddScannerComponent },


  //Documents
  { path: 'carrier/account/document/:id', component: UploaddocumentComponent },
  { path: 'document/type/add', component: DocumentTypeComponent },
  { path: 'document/type/edit/:id', component: DocumentTypeComponent },
  { path: 'document/type/list', component: ListDocumentTypeComponent },

  //Contact Page
  { path: 'contact/details/add', component: CaContactPageComponent },

  //Permit Applications
  { path: 'carrier/permit/application/:id', component: PermitApplicationComponent },
  { path: 'carrier/permit/application/mypermits/:id', component: PermitListApplicationComponent },
  { path: 'carrier/permit/application/cancel/permit/:id/:appid', component: PermitListApplicationComponent },
  { path: 'carrier/permit/application/new/:id', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/renew/:id/:crId/:type', component: RenewPermitComponent },
  { path: 'carrier/permit/application/edit/:id', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/edit/:id/:isSelectedVehicle', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/change/:id/:ctrlType', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/change/:id/:ctrlType/:selectType', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/change/:id/correction', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/change/:id/vehicle/selected-vehicle', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/duplicate/:id', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/duplicate/edit/:id', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/change/:id', component: NewPermitApplicationComponent },
  { path: 'carrier/process/permit/application/:id', component: PermitViewerComponent, canActivate: [AuthGuard]},
  { path: 'carrier/permit/application/view/:id', component: NewPermitApplicationComponent },
  { path: 'carrier/permit/application/view/:id/:constatus', component: NewPermitApplicationComponent },

  { path: 'carrier/permit/edit/:id/:edit', component: ViewPermitApplicationComponent },
  { path: 'carrier/documenttype/list', component: ListCarrierTypeDocumentComponent },
  { path: 'carrier/documenttype/add', component: CarrierTypeDocumentComponent },
  { path: 'carrier/documentttype/edit/:id', component: CarrierTypeDocumentComponent },

  { path: 'carrier-details', component: CarrierDetailsComponent },


  //Consultants
  { path: 'carrier/consultant/:id', component: ConsultantComponent },

  { path: 'route/management/add', component: AddRouteComponent },
  { path: 'route/management/list', component: ListRouteComponent },
  { path: 'route/management/edit/:id', component: AddRouteComponent },
  { path: 'permit/certificate/return', component: PermitCertificateReturnComponent },

  //Admin View Permits
  { path: 'maintain-view-permit', component: ViewPermitComponent },




  //Workflow
  { path: 'workflow/dashboard/list', component: WorkflowdashboardComponent },
  { path: 'approvals/permit/edit/:id', component: PermitViewerComponent },
  //Permit type document
  { path: 'permit/documenttype/list', component: ListPermitTypeDocumentComponent },
  { path: 'permit/documenttype/add', component: PermitTypeDocumentComponent },
  { path: 'permit/documentttype/edit/:id', component: PermitTypeDocumentComponent },




  //Permit type document
  { path: 'permit/documenttype/list', component: ListPermitTypeDocumentComponent },
  { path: 'permit/documenttype/add', component: PermitTypeDocumentComponent },
  { path: 'permit/documentttype/edit/:id', component: PermitTypeDocumentComponent },

  //approval-manager flow
  { path: 'permit/approval', component: ApprovalManagerComponent },
  { path: 'permit/approval/approved', component: ApprovalManagerComponent },
  { path: 'permit/approval/printed', component: ApprovalManagerComponent },
  { path: 'permit/approval/correspondence/:id', component: PermitCorrespondenceComponent },
  { path: 'permit/approval/view/:id', component: NewPermitApplicationComponent },
  { path: 'account/approval', component: ManagerComponent },
  { path: 'carrier/account/approval/:id', component: ManagerComponent, canActivate: [AuthGuard]},
  { path: 'carrier/approval/correspondence', component: CarriercorrespondenceComponent },
  { path: 'permit/approval/printing/:pId/:isapproved', component: PrintingComponent },
  //Admin Manage Countries
  { path: 'countries/list', component: ManageCountriesComponent },
  { path: 'countries/list/:type', component: ManageCountryPlacesComponent },
  { path: 'countries/add/:id', component: AddNewPlaceComponent },
  { path: 'countries/edit/:id/:placeId', component: AddNewPlaceComponent },
  //vehicle permit 
  { path: 'permit/vehicletype/list', component: ListPermitTypeVehicleComponent },
  { path: 'permit/vehicles', component: ManageVehiclesComponent },
  { path: 'permit/my-vehicles/:appid', component: ManageVehiclesComponent },
  { path: 'permit/vehicle-replace/:appid', component: ManageVehiclesComponent },



  //Run maintanance tasks
  { path: 'maintenance/tasks', component: RunMaintenanceTasksComponent },
  { path: 'correspondence/tasks', component: RunCorrespondenceTasksComponent },

  //under-construction
  { path: 'under-construction', component: UnderConstructionComponent },

  //Correspondences
  { path: 'corspdc/list', component: CorspdcComponent },
  { path: 'corspdc/batch', component: BatchComponent },

  //Carrier account linking
    { path: 'carrier/account/link', component: LinkCarrierAccountComponent },
    { path: 'carrier/account/delink', component: DeLinkCarrierAccountComponent },
  { path: 'timetable', component: TimetableComponent },

  //extract views
  { path: 'data', component: ExtractViewsComponent },
  { path: 'data/run/extracts', component: RunExtractsComponent },
  { path: 'data/add/extract', component: AddDataExtractComponent },

  //External Vehicles
  {path:'carrier/externalvehicles', component:ExternalVehiclesComponent},
  { path: 'carrier/vehicle/list', component: ExternalVehiclesComponent },

  //Calendar Viewer
  { path: 'calendar/viewer', component: CalendarViewerComponent },

  //carrier compliace list CarrierComplianceListComponent
  {path:'carrier/compliance/list', component:CarrierComplianceListComponent},
  {path:'carrier/compliance/return/list', component:ComplianceReturnListComponent},
  {path:'carrier/compliance/return/list/:carrierid/:calendarid', component:ComplianceReturnListComponent},
  {path:'carrier/compliance/return/list/:carrierid/:calendarid/:action/:appId', component:ComplianceReturnListComponent},
{ path: 'carrier/compliance/application',component:ComplianceApplicationComponent},
  {path:'support',component: SupportComponent},
  { path: '**', component: ErrorsComponent },

  
  

];

export const appRouting: ModuleWithProviders<unknown> = RouterModule.forRoot(appRoutes);

